import { useAuth } from "./useAuth";
import { userHasAccessRight } from "../utils";

export function useHasAccessClaim(claim: string) {
  const { staff_departments, active_tenant_id } = useAuth();

  const userCanToggleMode = userHasAccessRight(
    claim,
    active_tenant_id,
    staff_departments
  );

  return userCanToggleMode;
}
